import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as l } from "react";
import { I as n } from "../../../../IconBase-CxZyIWw2.js";
const t = l((a, e) => /* @__PURE__ */ o.jsx(
  n,
  {
    ref: e,
    ...a,
    image: (i) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...i,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M14 0a3 3 0 0 0-3 3l-.05 15.934c-.003.772-.835 1.229-1.4.703A8 8 0 0 1 7 13.78V9a2 2 0 1 0-4 0v4.78a12 12 0 0 0 5.916 10.344l.605.356A3 3 0 0 1 11 27.065V31a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-6.55c0-.947.492-1.825 1.3-2.319 3.567-2.18 6.634-6.95 6.634-11.131V8a2 2 0 1 0-4 0v3c0 1.832-1.119 4.07-2.477 5.716-.531.645-1.457.227-1.457-.608V3a3 3 0 0 0-3-3m11.44 18.787C31.575 25.09 29.003 32 23.604 32a4.64 4.64 0 0 1-3.255-1.318A4.44 4.44 0 0 1 19 27.5c0-2.035 1.395-3.37 2.796-4.71 1.143-1.093 2.289-2.19 2.685-3.673.111-.419.657-.641.96-.33",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
t.displayName = "CombinationIcon";
export {
  t as CombinationIcon,
  t as default
};
//# sourceMappingURL=index.js.map
